import { FC } from "react";
import { IconPropsType } from ".";

export const Home: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="13"
      height="14"
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.25 6.75H9.75V12C9.75 12.6904 9.19036 13.25 8.5 13.25H4.5C3.80964 13.25 3.25 12.6904 3.25 12V6.75Z"
        stroke={props.color}
        strokeWidth="1.5"
      />
      <path
        d="M1 5.5L6.5 1.5L12 5.5"
        stroke={props.color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
